import React, { Component } from 'react';
import { ButtonGroup } from '../buttonGroup/buttonGroup';
import Graph from './hospitalizationMap';
import Table from './hospitalizationMapTable';

//make this the index and pass phu table now

const viewModes = {
  map: 'map',
  table: 'table',
};

class HospitalizationMapIndex extends Component {
  state = {
    selectedViewMode: viewModes.map,
  };

  onViewModeChange = (viewMode) => {
    this.setState({
      selectedViewMode: viewMode,
    });
  };

  render() {
    const GetRightView = () => {
      switch (this.state.selectedViewMode) {
        case viewModes.map:
          return (
            <Graph
              showSidebar={true}
              selectedTab={this.props.selectedTab}
              lang={this.props.lang}
              startColor={[224, 216, 193]}
              endColor={[224, 72, 7]}
              hideChartMetric={this.props.hideChartMetric}
              fuzzySearchProp={this.props.fuzzySearchProp}
            />
          );
        case viewModes.table:
          return (
            <Table
              selectedTab={this.props.selectedTab}
              lang={this.props.lang}
            />
          );
        default:
      }
    };

    return (
      <div id="">
        <>
          <ButtonGroup
            selected={this.state.selectedViewMode}
            viewModes={viewModes}
            lang={this.props.lang}
            handleOnClick={this.onViewModeChange}
          />
          <GetRightView />
        </>
      </div>
    );
  }
}
export default HospitalizationMapIndex;
